import { useState, useEffect } from 'react';
import { Button, Modal, RadioGroup } from '@teo/components';
import { useTranslation } from 'react-i18next';

const RedoModalLp = ({ closeModal, setIsOpenRedoModal, setAction }: any) => {
  const { t } = useTranslation();
  const [isChecked, setIsChecked] = useState('complete');

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        closeModal();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [closeModal]);

  return (
    <div className="bg-white">
      <div className="fixed inset-0 z-[100] flex rounded-xl bg-white/75 px-3">
        <div className="mx-auto my-8 h-max w-full max-w-xl  rounded-xl bg-white drop-shadow-m">
          <Modal.Header onClose={closeModal}>
            <h2 className="text-sm font-semibold">
              {t('pages.lp_correction.re_take')}
            </h2>
          </Modal.Header>

          <Modal.Body>
            <div className="flex flex-col gap-3">
              <div>
                <h3 className="mb-3 text-lg">
                  {t('pages.follow_up_courses.redo_modal.heading')}
                </h3>
                <p className="text-sm text-grey-06">
                  {t('pages.follow_up_courses.redo_modal.text')}
                </p>
              </div>
              <RadioGroup
                label={''}
                onChange={(value: string) => {
                  setIsChecked(value);
                }}
                value={isChecked}
              >
                <div className="mb-3 flex w-full flex-col gap-3">
                  <div
                    className={`w-full rounded-lg border border-grey-02 p-3 ${
                      isChecked == 'complete' && 'border-secondary-04'
                    }`}
                  >
                    <RadioGroup.Option value="complete">
                      <span className="text-sm">
                        {t('pages.follow_up_courses.redo_modal.checkbox_1')}
                      </span>
                    </RadioGroup.Option>
                  </div>
                  <div
                    className={`w-full rounded-lg border border-grey-02 p-3 ${
                      isChecked == 're-enter' && 'border-secondary-04'
                    }`}
                  >
                    <RadioGroup.Option value="re-enter">
                      <span className="text-sm" data-testid="radio_btn">
                        {t('pages.follow_up_courses.redo_modal.checkbox_2')}
                      </span>
                    </RadioGroup.Option>
                  </div>
                </div>
              </RadioGroup>
              <div className="flex justify-between">
                <Button
                  variant="ghost"
                  onClick={() => setIsOpenRedoModal(false)}
                >
                  {t('button.cancel')}
                </Button>
                <Button
                  onClick={() => {
                    setAction(isChecked);
                    setIsOpenRedoModal(false);
                  }}
                >
                  {t('button.confirm')}
                </Button>
              </div>
            </div>
          </Modal.Body>
        </div>
      </div>
    </div>
  );
};

export default RedoModalLp;
